`import {Vote} from '../models/resources'`

actions =
  getVotes: (context) ->
    new Promise((resolve, reject) ->
      Vote.query().then (response) ->
        context.commit('votes', response.body.data.map((vote) -> vote.attributes))
      resolve()
    )

  addVote: (context, vote) ->

    new Promise((resolve, reject) ->
      context.commit('addVote', vote)
      resolve()
    )

  editVote: (context, vote) ->
    new Promise (resolve, reject) ->
      context.commit('editVote', vote)
      resolve()

  deleteVote: (context, vote) ->
    Vote.delete({id: vote.id}).then (res) ->
      context.commit('deleteVote', vote)

  saveVote:  (context, sentence) ->
    rs = Vote

    vote =
      model_id: sentence.id
      model_type: 'Sentence'

    new Promise((resolve, reject) ->
      rs.save(vote).then(
        (res) ->
          context.commit('editSentence', Object.assign({}, sentence, {vote_id: res.body.id, votes_nb: sentence.votes_nb+1}))
          context.commit('addVote', res.body.data.attributes)
          resolve(res)
      , (res) ->
        reject(res)
      )
    )


`export default actions`



// WEBPACK FOOTER //
// ./src/store/actions/votes.coffee